import * as tslib_1 from "tslib";
import ReadOnlyRecipientWell from './ReadOnlyRecipientWell';
import { observer } from 'mobx-react';
import { lazySubscribeToResizeEvent, lazyUnsubscribeFromResizeEvent } from 'owa-resize-event';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
var styles = require('./ReadOnlyTruncatedRecipientWell.scss');
var trailingComponentMaxWidth = 70;
var timeoutForTruncation = 1; /* There are issues on some browsers with a 0 timeout, but a 1ms timeout ends up behaving the same */
var ReadOnlyTruncatedRecipientWell = /** @class */ (function (_super) {
    tslib_1.__extends(ReadOnlyTruncatedRecipientWell, _super);
    function ReadOnlyTruncatedRecipientWell(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            if (!_this.resizeThrottlingJob) {
                _this.resizeThrottlingJob = window.requestAnimationFrame(function () {
                    _this.resizeThrottlingJob = 0;
                    _this.setState(_this.getShowAllRecipientsState());
                    _this.truncateRecipientsIfNecessary();
                });
            }
        };
        _this.state = _this.getShowAllRecipientsState();
        return _this;
    }
    ReadOnlyTruncatedRecipientWell.prototype.getShowAllRecipientsState = function (newProps) {
        var props = newProps ? newProps : this.props;
        return {
            recipientsShown: props.recipients.slice(),
            truncatedCount: props.totalRecipientCount - props.recipients.length,
        };
    };
    ReadOnlyTruncatedRecipientWell.prototype.truncateRecipientsIfNecessary = function () {
        if (!this.containerRef || !this.wellRef) {
            return;
        }
        var maxWidth = this.containerRef.offsetWidth;
        var actualWidth = this.containerRef.scrollWidth;
        if (maxWidth == 0 || actualWidth - 1 <= maxWidth) {
            // No need to truncate in this case.
            // In IE/Edge, scrollWidth is off by 1px compared to offsetWidth
            // For details, see http://stackoverflow.com/questions/30900154/workaround-for-issue-with-ie-scrollwidth
            // So here we add a tolerance check of 1px.
            return;
        }
        for (var i = this.state.recipientsShown.length - 1; i > 0; i--) {
            var recipientRef = this.wellRef.recipientsParentRef.children[i];
            actualWidth -= recipientRef.offsetWidth;
            this.state.recipientsShown.splice(i, 1);
            if (actualWidth + trailingComponentMaxWidth <= maxWidth || i == 1) {
                // Stop truncation here and set state to re-render.
                this.setState({
                    recipientsShown: this.state.recipientsShown,
                    truncatedCount: this.props.totalRecipientCount - this.state.recipientsShown.length,
                });
                break;
            }
        }
    };
    ReadOnlyTruncatedRecipientWell.prototype.componentWillUnmount = function () {
        lazyUnsubscribeFromResizeEvent.importAndExecute(this.onResize);
        if (this.resizeThrottlingJob) {
            window.cancelAnimationFrame(this.resizeThrottlingJob);
            this.resizeThrottlingJob = 0;
        }
    };
    ReadOnlyTruncatedRecipientWell.prototype.componentDidMount = function () {
        var _this = this;
        lazySubscribeToResizeEvent.importAndExecute(this.onResize);
        setTimeout(function () {
            _this.truncateRecipientsIfNecessary();
        }, timeoutForTruncation);
    };
    ReadOnlyTruncatedRecipientWell.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.renderSelf != newProps.renderSelf) {
            //Update the state if the renderSelf flag flips.
            this.setState(this.getShowAllRecipientsState(newProps));
            this.shouldTruncateOnPropUpdate = true;
        }
    };
    ReadOnlyTruncatedRecipientWell.prototype.componentDidUpdate = function () {
        if (this.shouldTruncateOnPropUpdate) {
            this.truncateRecipientsIfNecessary();
            this.shouldTruncateOnPropUpdate = false;
        }
    };
    ReadOnlyTruncatedRecipientWell.prototype.render = function () {
        var _this = this;
        var trailingComponent = (React.createElement("span", null,
            this.state.truncatedCount ? (React.createElement("span", { onClick: this.props.onToggleIsTruncated }, format(strings.plusOthers, this.state.truncatedCount))) : (''),
            this.props.trailingComponent));
        return (React.createElement("div", { className: styles.truncatedRecipientsContainer, ref: function (ref) { return (_this.containerRef = ref); } },
            React.createElement(ReadOnlyRecipientWell, { ref: function (ref) { return (_this.wellRef = ref); }, recipientType: this.props.recipientType, recipients: this.state.recipientsShown, trailingComponent: trailingComponent, renderSelf: this.props.renderSelf, disableHover: this.props.disableHover })));
    };
    ReadOnlyTruncatedRecipientWell = tslib_1.__decorate([
        observer
    ], ReadOnlyTruncatedRecipientWell);
    return ReadOnlyTruncatedRecipientWell;
}(React.Component));
export default ReadOnlyTruncatedRecipientWell;
//# sourceMappingURL=ReadOnlyTruncatedRecipientWell.js.map